import React, { useState, useEffect } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from '../config/authConfig';

const Login = () => {
  const { instance, inProgress, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  // Redirect to dashboard if already authenticated
  useEffect(() => {
    if (isAuthenticated && accounts.length > 0 && inProgress === InteractionStatus.None) {
      console.log('✅ Already authenticated, redirecting to dashboard...');
      const from = location.state?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, accounts, inProgress, navigate, location]);

  const handleLogin = async () => {
    console.log('Login button clicked');
    setIsLoading(true);
    try {
      console.log('Starting MSAL login redirect...');
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Login error:', error);
      setIsLoading(false);
    }
  };

  const systemSpecs = [
    { label: 'REGION', value: 'EU-WEST-1 (PRIMARY)' },
    { label: 'CLUSTER', value: 'COMPLIANCE-PROD-01' },
    { label: 'ENCRYPTION', value: 'AES-256-GCM' },
  ];

  const complianceStandards = ['ISO27001', 'GDPR', 'SOC2'];

  return (
    <div className="login-container enterprise-login">
      <div className="login-content">
        <div className="logo-section">
          <img src="/transtar-logo.png" alt="Transtar Networks" className="enterprise-logo" />
        </div>

        <div className="info-cards">
          {systemSpecs.map((spec, index) => (
            <div key={index} className="info-card">
              <div className="card-label">{spec.label}</div>
              <div className="card-value">{spec.value}</div>
            </div>
          ))}
        </div>

        <div className="auth-card">
          <div className="auth-header">
            <div className="secure-indicator">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              <span>Secure Authentication</span>
            </div>
          </div>

          <button
            onClick={handleLogin}
            disabled={isLoading}
            className="enterprise-auth-button"
          >
            {isLoading ? (
              <>
                <span className="auth-spinner"></span>
                <span>Authenticating...</span>
              </>
            ) : (
              <>
                <svg className="ms-icon" viewBox="0 0 23 23" fill="none">
                  <rect width="11" height="11" fill="#f25022"/>
                  <rect x="12" width="11" height="11" fill="#7fba00"/>
                  <rect y="12" width="11" height="11" fill="#00a4ef"/>
                  <rect x="12" y="12" width="11" height="11" fill="#ffb900"/>
                </svg>
                <span>Sign in with Microsoft</span>
              </>
            )}
          </button>
        </div>

        <div className="compliance-badges">
          {complianceStandards.map((standard, index) => (
            <div key={index} className="compliance-badge">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22 4 12 14.01 9 11.01"/>
              </svg>
              <span>{standard}</span>
            </div>
          ))}
        </div>

        <div className="footer-notice">
          <p>Authorized Access Only · Secure Encrypted Channel<br/>Transtar Networks</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
